
// FIXME: handle translations

const usersConfigEditShape = new Map();

usersConfigEditShape.set('role', {
  width: '16',
  kind: 'select',
  options: [
    {
      key: 'user',
      text: 'user',
      value: 'user',
    },
    {
      key: 'configurator',
      text: 'configurator',
      value: 'configurator',
    },
    {
      key: 'admin',
      text: 'admin',
      value: 'admin',
    },
  ],
  label: 'Role',
  required: true,
});

export default usersConfigEditShape;



// WEBPACK FOOTER //
// ./src/shapes/usersConfigEditShape.js